module.exports = __webpack_public_path__ + "static/media/rin-theme.6f05d056.wav";